import {Mount} from "../enums";

export const CanonMounts = [
  Mount.CANON_EF,
  Mount.CANON_EF_S,
  Mount.CANON_RF,
  Mount.CANON_RF_S,
  Mount.CANON_M,
];

export const NikonMounts = [
  Mount.NIKON_F,
  Mount.NIKON_F_DX,
  Mount.NIKON_Z,
  Mount.NIKON_Z_DX,
];

export const SonyMounts = [
  Mount.SONY_E,
  Mount.SONY_E_APS_C,
];

export const PentaxMounts = [
  Mount.PENTAX_K,
  Mount.PENTAX_K_APS_C,
];

export const FujifilmMounts = [
  Mount.FUJIFILM_X,
];
